<template>
  <div>
    <column-config v-if="id === 'columns'" />
    <data-config v-if="id === 'data-config'" />
  </div>
</template>

<script>
import ColumnConfig from './ColumnConfig.vue';
import DataConfig from './DataConfig.vue';

export default {
  name: 'AdminWindow',
  components: {
    ColumnConfig,
    DataConfig,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
};
</script>
